import type { ReactNode } from "react";
import { cn } from "@/lib/cn";
import { toneClasses, type BadgeTone } from "@/components/ui/badgeTones";

interface Props {
  /** Meaning (`success`, `danger`, …) or a categorical `kind-N`. */
  tone: BadgeTone;
  children: ReactNode;
  className?: string;
  title?: string;
}

/**
 * Status / type pill coloured ONLY by a badge tone (TASK-5133, DEV_RULES
 * §10.10). Use it instead of writing `bg-green-100 text-green-700` inline;
 * pass `className` for size/shape tweaks, never for colour.
 */
export function StatusBadge({ tone, children, className, title }: Props) {
  return (
    <span
      title={title}
      className={cn(
        "inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold",
        toneClasses(tone),
        className,
      )}
    >
      {children}
    </span>
  );
}
